import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  private readonly isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          const converted = this.convertDates(event.body);
          return event.clone({ body: converted });
        }
        return event;
      })
    );
  }

  private isIsoDateString(value: any): boolean {
    return typeof value === 'string' && this.isoDateRegex.test(value);
  }

  private convertDates(obj: any): any {
    if (obj === null || obj === undefined) return obj;

    if (Array.isArray(obj)) {
      return obj.map(item => this.convertDates(item));
    }

    if (typeof obj === 'object') {
      const result: any = {};
      for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (this.isIsoDateString(value)) {
          result[key] = new Date(value);
        } else {
          result[key] = this.convertDates(value);
        }
      }
      return result;
    }

    return obj;
  }
}
